import { render, staticRenderFns } from "./PfiOnboarding.vue?vue&type=template&id=25ca1462&scoped=true&"
import script from "./PfiOnboarding.vue?vue&type=script&lang=js&"
export * from "./PfiOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./PfiOnboarding.vue?vue&type=style&index=0&id=25ca1462&lang=scss&scoped=true&"
import style1 from "./PfiOnboarding.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca1462",
  null
  
)

export default component.exports